module.exports = __webpack_public_path__ + "img/1545509992.b084e40d.jpg";